
/**
 * First we will load all of this project's JavaScript dependencies which
 * includes Vue and other libraries. It is a great starting point when
 * building robust, powerful web applications using Vue and Laravel.
 */

const Sentry = require('@sentry/browser');
Sentry.init({ dsn: process.env.MIX_SENTRY_JS_DSN });

require('../../../node_modules/chart.js/dist/Chart.min.js');
require('../../../node_modules/jquery-validation/dist/jquery.validate.min.js');
require('./jquery.validate.ext.js');


require('./variabili');
require('./funzioni');
require('./eventi');
require('./validazione_forms');
require('./contatti');
require('./calcola-mutuo');
require('./mutuo-senza-preoccupazioni');
require('./cambia-mutuo');
require('./mutuo-perfetto');
require('./lavora-con-noi');
require('./commenti');
require('jquery-ui/ui/widgets/slider');
require('./valor_inmueble');
require('./estoy_alquilando');

window.Vue = require('vue');
// import Vue from 'vue';
import Vue from 'vue/dist/vue.js';

import GoogleMap from './components/GoogleMap.vue';
import grafico from './components/Grafico.vue';
import HomeNews from './components/HomeNews.vue';
import HomeReviews from './components/HomeReviews.vue';

Vue.component('grafico', grafico);
Vue.component('GoogleMap', GoogleMap);
Vue.component('home-news', HomeNews);
Vue.component('home-reviews', HomeReviews);

/*const app = new Vue({
    el: '#area-grafico',
});*/

const app = new Vue({
    el: '#app',
});

import * as AOS from 'aos';
import 'aos/dist/aos.css';

window.addEventListener("load", () => {
    AOS.init({
        easing: 'ease-out-back',
        once: true,
    });
});
